import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LocationService } from 'app/masters/location-master/location.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AuthService } from 'app/auth/auth.service';
import { smsconfig, smsMaster } from '../dashboard-config.model';
import { ConfigurationService } from '../configuration.service';
@Component({
  selector: 'app-sms-configuration',
  templateUrl: './sms-configuration.component.html',
  styleUrls: ['./sms-configuration.component.scss']
})
export class SmsConfigurationComponent implements OnInit {
  smstemplateData: any[] = [];
  smstemplatespellData: any;
  sendingtypeData: any;
  smsConfig: smsconfig = new smsconfig(); 
  smstemplatemasterData: any;
  masterData: any;
  selectedSmsMaster: smsMaster = new smsMaster(); 
  selectedSmsType: any;
  branchList: any[];
  branchlistControl = new FormControl('');
  filteredbranchArray: Observable<any[]>;


  constructor(public locationService: LocationService, public authservice: AuthService,
   public ConfigurationService: ConfigurationService
  ) { 
  }
  ngOnInit(): void {
    this.SMSTEMPLATEPARAMETERS()
    this.SMSTEMPLATENAMESPELLING()
    this.SMSSendingType()
    this.getBranch()
    this.getSmsMasterConfigurationByBranchId()
    this.GetSmsTemplateMasterByBranchIdByTranId(this.authservice.Loggeduser.branchid , 0)
   }

   getBranch() {
    this.locationService.getallBranches().subscribe((branch: any[]) => {
      this.branchList = branch;
      if (branch.length > 0) {
        this.branchlistControl.setValue(branch[0].branchName);
        this.smsConfig.name = branch[0].branchName
        this.smsConfig.fK_BranchId = branch[0].pkBranchId
      }
      
      this.initializeBranchFilter();
    });
  }

  initializeBranchFilter() {
    this.filteredbranchArray = this.branchlistControl.valueChanges.pipe(
      startWith(''),
      map((value) =>
        value ? this.filterbranchlistFunction(value) : this.branchList.slice()
      )
    );
  }
  

  filterbranchlistFunction(name: string): any[] {
    return this.branchList.filter((b) =>
      b.branchName.toLowerCase().includes(name.toLowerCase())
    );
  }
  onbranchSelected(branch: any) {
    this.selectedSmsMaster = new smsMaster()
    const selectedBranch = this.branchList.find((b: any) => b.branchName == branch);
    if (selectedBranch) {
      this.smsConfig.name = selectedBranch.branchName;
      this.smsConfig.fK_BranchId = selectedBranch.pkBranchId;
      this.getSmsMasterConfigurationByBranchId()
      this.GetSmsTemplateMasterByBranchIdByTranId(this.smsConfig.fK_BranchId ,0)
    }
  }
  onbranchChange(event:KeyboardEvent){
    const branchValue = (event.target as HTMLInputElement).value
    if (branchValue == ''){
      this.smsConfig.name = null;
      this.smsConfig.fK_BranchId =null;  
      this.smsConfig = new smsconfig();
      this.selectedSmsMaster = new smsMaster()
    }
  }
    SMSTEMPLATEPARAMETERS(){
      this.ConfigurationService.SMSTEMPLATEPARAMETERS().subscribe((data) => {
      this.smstemplateData = data;
      });

    }
    SMSTEMPLATENAMESPELLING(){
      this.ConfigurationService.SMSTEMPLATENAMESPELLING().subscribe((data) => {
        this.smstemplatespellData = data;
      });
    }    
    SMSSendingType(){
      this.ConfigurationService.SMSSendingType().subscribe((data) => {
        this.sendingtypeData = data;
      });
    }
   
    getSmsMasterConfigurationByBranchId() {
      const branchId = this.smsConfig.fK_BranchId || this.authservice.Loggeduser.branchid;
      this.ConfigurationService.GetSmsMasterConfigurationByBranchId(branchId).subscribe((data: smsconfig[]) => {
        if (data && data.length > 0) {
          this.smsConfig = data[0]; 
          this.smsConfig.route.trim()
          this.smsConfig.numberValue.trim( )
        }
      });
    }
  
    InsertSmsConfiguration(event) {
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
        setTimeout(function () {
      button.removeAttribute('disabled');
      }, 3000);
    
      const payload = {
        SmsConfiguration: {
          pK_TranId: this.smsConfig.pK_TranId || 0,
          fK_BranchId: this.smsConfig.fK_BranchId,
          initialURL: this.smsConfig.initialURL,
          userNameField: this.smsConfig.userNameField,
          userNameValue: this.smsConfig.userNameValue,
          passwordField: this.smsConfig.passwordField,
          passwordValue: this.smsConfig.passwordValue,
          senderField: this.smsConfig.senderField,
          senderValue: this.smsConfig.senderValue,
          numberField: this.smsConfig.numberField,
          numberValue: this.smsConfig.numberValue,
          messageField: this.smsConfig.messageField,
          routeField: this.smsConfig.routeField,
          route: this.smsConfig.route,
          authenticationKeyField: this.smsConfig.authenticationKeyField,
          authenticationKeyValue: this.smsConfig.authenticationKeyValue,
          isActive: this.smsConfig.isActive,
          isEdit: this.smsConfig.pK_TranId > 0
        }
      };
  
      this.ConfigurationService.InsertSmsConfiguration(payload).subscribe(
        (response) => {
          if (response.statusCode == 1) {
            if ( this.smsConfig.pK_TranId > 0) {
              this.locationService.openSnackBar('Record Updated Successfully', 'OK');
            } else {
              this.locationService.openSnackBar('Record Saved Successfully', 'OK');
            }         
           } 
          this.getSmsMasterConfigurationByBranchId()

        },
        err => {
          if (err.status == 403) {
            this.locationService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.locationService.openSnackBar(err.error.message, "OK");
          } else {
            this.locationService.openSnackBar("API Failed", "OK");
          }
        }
      );
    }

    GetSmsTemplateMasterByBranchIdByTranId(id1,id2){
      this.ConfigurationService.GetSmsTemplateMasterByBranchIdByTranId(id1,id2).subscribe((data) => {
        this.smstemplatemasterData = data
        if (data.length > 0) {
          const firstTranId = data[0].pK_TranId; 
          this.selectedSmsType = data[0];
          this.getsmsMaster(this.selectedSmsMaster.fK_BranchId, firstTranId );
        }
      });
    }

    getsmsMaster(id1,id2){
      this.ConfigurationService.GetSmsTemplateMasterByBranchIdByTranId(id1,id2).subscribe((data) => {
        this.masterData = data
        
        if (data.length > 0) {
          let sms = data[0]; 
          this.selectedSmsMaster.pK_TranId = sms.pK_TranId;
          this.selectedSmsMaster.fK_BranchId = sms.fK_BranchId;
          this.selectedSmsMaster.smsType = sms.smsType;
          this.selectedSmsMaster.smsTemplate = sms.smsTemplate;
          this.selectedSmsMaster.startTime = sms.startTime;
          this.selectedSmsMaster.endTime = sms.endTime;
          this.selectedSmsMaster.sendingType = sms.sendingType;
          this.selectedSmsMaster.totalSENTSMS = sms.totalSENTSMS;
          this.selectedSmsMaster.isActive = sms.isActive;
          this.selectedSmsMaster.template_Type = sms.template_Type;
          this.selectedSmsMaster.smsRestrictionDateValue = sms.smsRestrictionDateValue;
          this.selectedSmsMaster.smsTemplateLocal = sms.smsTemplateLocal;
          this.selectedSmsMaster.smsExpiryDays = sms.smsExpiryDays;
          this.selectedSmsMaster.branchName = sms.branchName;
        }
      });
    }

    getsmstypedata(sms: any) {
      this.selectedSmsType = sms;
      this.selectedSmsMaster.pK_TranId = sms.pK_TranId;
      this.selectedSmsMaster.fK_BranchId = sms.fK_BranchId;
      this.selectedSmsMaster.smsType = sms.smsType;
      this.selectedSmsMaster.smsTemplate = sms.smsTemplate;
      this.selectedSmsMaster.startTime = sms.startTime;
      this.selectedSmsMaster.endTime = sms.endTime;
      this.selectedSmsMaster.sendingType = sms.sendingType;
      this.selectedSmsMaster.totalSENTSMS = sms.totalSENTSMS;
      this.selectedSmsMaster.isActive = sms.isActive;
      this.selectedSmsMaster.template_Type = sms.template_Type;
      this.selectedSmsMaster.smsRestrictionDateValue = sms.smsRestrictionDateValue;
      this.selectedSmsMaster.smsTemplateLocal = sms.smsTemplateLocal;
      this.selectedSmsMaster.smsExpiryDays = sms.smsExpiryDays;
      this.selectedSmsMaster.branchName = sms.branchName;

    }
    saveSmsTemplate(event) {
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      setTimeout(function () {
        button.removeAttribute('disabled');
      }, 5000);
      const payload = {
        SmsTemplateMaster: {
          PK_TranId: this.selectedSmsMaster.pK_TranId,
          FK_BranchId:  this.smsConfig.fK_BranchId,
          SMSType: this.selectedSmsMaster.smsType,
          SMSTemplate: this.selectedSmsMaster.smsTemplate,
          StartTime: this.selectedSmsMaster.startTime,
          EndTime: this.selectedSmsMaster.endTime,
          SendingType: this.selectedSmsMaster.sendingType,
          TotalSENTSMS: this.selectedSmsMaster.totalSENTSMS,
          Template_Type: this.selectedSmsMaster.template_Type,
          Title: this.selectedSmsMaster.title ,
          SMSTemplateLocal: this.selectedSmsMaster.smsTemplateLocal,
          SMSExpiryDays: this.selectedSmsMaster.smsExpiryDays || 8,
          IsActive: this.selectedSmsMaster.isActive,
          isEdit: this.selectedSmsMaster.pK_TranId > 0 ? true : false
        }
    }
      this.ConfigurationService.InsertSmsTemplateMaster(payload).subscribe(
        (response: any) => {
          if (response.statusCode === '1') {
            this.locationService.openSnackBar('Record updated successfully' , 'OK');
            this.GetSmsTemplateMasterByBranchIdByTranId( this.smsConfig.fK_BranchId , 0)
          } else {
            this.locationService.openSnackBar('Failed to save sms template' , 'OK');
          }
        },
        err => {
          if (err.status == 403) {
            this.locationService.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.locationService.openSnackBar(err.error.message, "OK");
          } else {
            this.locationService.openSnackBar("API Failed", "OK");
          }
        }
      );
    }
    


    appendTemplateSpelling(spelling: string) {
      if (this.selectedSmsType) {
        const exists = this.smstemplatemasterData.some(
          (sms) => sms.smsType.trim().toLowerCase() === spelling.trim().toLowerCase()
        );
    
        if (exists) {
          this.locationService.openSnackBar('Already exists in the list','OK' );
          return;
        }
      if (this.selectedSmsType) {
        const newSms = { ...this.selectedSmsType };
    
        newSms.smsType = spelling;
        newSms.pK_TranId = 0; 
        newSms.isActive = true; 
        newSms.smsTemplate = ''; 
    
        this.smstemplatemasterData.push(newSms);
        this.selectedSmsType = newSms; 
        this.getsmstypedata(newSms);
      }
    }
    
    
  }
}